// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth"
import { CACHE_SIZE_UNLIMITED, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore"
import { getStorage, ref } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  "apiKey": "AIzaSyBi2ScdkaJk2tCtY96lTkWa9iIgEOL7bO4",
  "authDomain": "wildsync.firebaseapp.com",
  "projectId": "wildsync",
  "storageBucket": "wildsync.appspot.com",
  "messagingSenderId": "373140797619",
  "appId": "1:373140797619:web:de5a7aee294f6a3ceb98c6",
  "measurementId": "G-PJT9GEJMZD",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);
const auth = getAuth(firebaseApp);
// const firestoreDB = getFirestore(firebaseApp);
const firestoreDB = initializeFirestore(firebaseApp, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
    cacheSizeBytes: CACHE_SIZE_UNLIMITED
  })
});
const storage = getStorage(firebaseApp);
const storageRef = ref(firebaseApp)


export { firebaseApp, analytics, auth, firestoreDB, storage, storageRef };